import { PaymentConst } from "../../../utils/payment";
import { useContext, useEffect } from "react";
import PaymentContext from "../../../store/PaymentContext";
import { Radio } from "antd";

const DeliveryType = () => {
    const {
        tabActiveStep1,
        sellAdditionalInformation,
        rentAdditionalInformation,
        setRentAdditionalInformation,
        setSellAdditionalInformation,
        handleCalculateFee,

        rentCustomer,
        sellCustomer,
        rentCarts,
        sellCarts,
    }: any = useContext(PaymentContext)

    const additionalInformation = Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent) ? rentAdditionalInformation : sellAdditionalInformation;
    const setAdditionalInformation = Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent) ? setRentAdditionalInformation : setSellAdditionalInformation;
    const baseCustomer = Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent) ? rentCustomer : sellCustomer
    const carts = Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent) ? rentCarts : sellCarts;


    useEffect(() => {
        console.log(Number(tabActiveStep1));
        handleCalculateFee(
            carts,
            Number(tabActiveStep1) === Number(PaymentConst.TabConst.buy),
            baseCustomer,
            {
                ...additionalInformation,
            }
        );
    }, [
        // Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent) ? rentAdditionalInformation : sellAdditionalInformation,
        // Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent) ? rentCustomer : sellCustomer
    ])

    return (
        <div className="box-info p-4 rounded-lg">
            <div className="bold text-lg">Phương thức nhận hàng</div>
            <div className=" grid grid-cols-1 md:grid-cols-2 gap-2">
                {
                    PaymentConst.DeliveryTypeList.map((item, index) => {

                        return (
                            <div
                                className="p-4 rounded box-item bg-white" key={index}
                                onClick={() => {
                                    setAdditionalInformation({
                                        ...additionalInformation,
                                        delivery_type: item.value
                                    })

                                    handleCalculateFee(
                                        carts,
                                        tabActiveStep1 == PaymentConst.TabConst.buy,
                                        baseCustomer,
                                        {
                                            ...additionalInformation,
                                            delivery_type: item.value
                                        }
                                    );
                                }}
                            >
                                <Radio
                                    name="delyvery_type"
                                    checked={additionalInformation.delivery_type === item.value}
                                    className={`${additionalInformation.delivery_type === item.value ? 'cart__checkbox-active' : ''}`}
                                >
                                    {
                                        item.label
                                    }
                                </Radio>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default DeliveryType;
